import { useButton } from '@react-aria/button';
import { clsx } from 'clsx';

import type { AriaButtonProps } from '@react-aria/button';
import type { IconProps } from 'components/Icon';
import type { RefObject } from 'react';
import type { UIButtonVariant } from 'types/UserInterface';

import { Icon } from 'components/Icon';
import styles from 'components/Buttons/Button.module.css';

export interface MenuButtonProps extends AriaButtonProps<'button'> {
  buttonRef: RefObject<HTMLButtonElement>;
  /** The variant of the button. */
  variant: UIButtonVariant;
  /** The icon to show. */
  iconName?: IconProps['name'];
}

/** Represents a button that is used to open a menu. */
export function MenuButton({ buttonRef, variant, iconName, children, ...restProps }: MenuButtonProps) {
  const { buttonProps } = useButton(restProps, buttonRef);

  return (
    <button {...buttonProps} ref={buttonRef} className={clsx(styles['button'], styles[`button--${variant}`])}>
      {children}
      {iconName && <Icon name={iconName} />}
    </button>
  );
}
